import type { LocalizedDict } from '../index'

export type SampleRequestDetailStrings = {
  reference: string
  listing: string
  setAsMain: string
  remove: string
  useInBrief: string
  use: string
  loading: string
  back: string
  exporting: string
  exportPdf: string
  sample: string
  preparing: string
  print: string
  sampleRequest: string
  status: string
  referenceListings: string
  noReferences: string
  pasteEtsyHint: string
  adding: string
  add: string
}

export const sampleRequestDetailI18n: LocalizedDict<SampleRequestDetailStrings> = {
  en: {
    reference: 'Reference',
    listing: 'listing',
    setAsMain: 'Set as main',
    remove: 'Remove',
    useInBrief: 'Use in brief',
    use: '+ Use',
    loading: 'Loading…',
    back: 'Back',
    exporting: 'Exporting…',
    exportPdf: 'Export PDF',
    sample: 'Sample',
    preparing: 'Preparing…',
    print: 'Print',
    sampleRequest: 'Sample Request',
    status: 'Status: ',
    referenceListings: 'Reference Listings',
    noReferences: 'No references yet. ',
    pasteEtsyHint: 'Paste an Etsy URL above to add one.',
    adding: 'Adding…',
    add: '+ Add',
  },
  tr: {
    reference: 'Referans',
    listing: 'ilan',
    setAsMain: 'Ana yap',
    remove: 'Kaldır',
    useInBrief: 'Brifte kullan',
    use: '+ Kullan',
    loading: 'Yükleniyor…',
    back: 'Geri',
    exporting: 'Dışa aktarılıyor…',
    exportPdf: 'PDF indir',
    sample: 'Numune',
    preparing: 'Hazırlanıyor…',
    print: 'Yazdır',
    sampleRequest: 'Numune talebi',
    status: 'Durum: ',
    referenceListings: 'Referans ilanlar',
    noReferences: 'Henüz referans yok. ',
    pasteEtsyHint: 'Eklemek için yukarıya bir Etsy bağlantısı yapıştır.',
    adding: 'Ekleniyor…',
    add: '+ Ekle',
  },
}
